
export default function helpButtonHandler() {
    const helpWrapper = document.querySelector('.help-wrapper');
    if (!helpWrapper) {
        return;
    }

    let helpdeskLoaded = false;
    //initialize helpdesk on demand

    helpWrapper.querySelector('button').addEventListener("click", function() {
        const key = helpWrapper.getAttribute('data-key');
        const name = helpWrapper.getAttribute('data-name');
        const email = helpWrapper.getAttribute('data-email');

        if (!helpdeskLoaded) {
            const jsScript = document.createElement('script');
            jsScript.setAttribute('id', 'ze-snippet');
            jsScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + key;
            document.body.appendChild(jsScript);

            jsScript.onload = function () {
                window.zESettings = {
                    webWidget: {
                        chat: {
                            // connectOnPageLoad: false
                        },
                    }
                };

                zE(function () {
                    if (name && email) {
                        zE.identify({
                            name: name,
                            email: email
                        });
                    }
                    zE.activate();
                    //hide our custom button and use zendesks's instead after load
                    helpWrapper.style.display = 'none';
                });
            };
            helpdeskLoaded = true;

            return;
        }

        zE.activate();
    });
}
